<div class="dropdown-item-wrapper">
  <rt-feature-guard-dropdown-item
    [mode]="featureGuardMode.Dialog"
    [feature]="featureGuard"
    [iconName]="iconName"
    [heading]="heading"
    [subheading]="subheading"
  >
    <rt-dropdown-item
      [highlighted]="selected"
      (click)="stepInside.emit($event)"
      [hasChevronRight]="true"
    >
      <rt-icon prefix [size]="'medium'" [name]="iconName"> </rt-icon>

      <div layout layout-vertical>
        <rt-heading variant="heading">
          {{ heading }}
          <rt-badge
            *ngIf="badgeText"
            color="primary"
            [text]="badgeText"
            margin-left-small
          ></rt-badge>
        </rt-heading>
        <div class="info-dropdown-text">
          {{ subheading }}
        </div>
      </div>
    </rt-dropdown-item>
  </rt-feature-guard-dropdown-item>
</div>
